import { render, staticRenderFns } from "./IdentifyJobTable.vue?vue&type=template&id=5250c86c"
import script from "./IdentifyJobTable.vue?vue&type=script&lang=js"
export * from "./IdentifyJobTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports